import StylistFeed from 'containers/stylist_feed';
import { useUrlQuery } from 'hooks/useUrlQuery';

export const SearchStylistPage = () => {
    const query = useUrlQuery();
    return <StylistFeed searchKey={query.get('search') as string} />;
};
